import { Campaign } from '@/core/api/entities/campaign/campaign'
import { Playlist } from '@/core/api/entities/playlist/playlist'
import { Mix } from '@/core/api/entities/radio/mix'
import { MusicProfile } from '@/core/api/entities/radio/musicProfile'
import { Radio } from '@/core/api/entities/radio/radio'
import { Zone } from '@/core/api/entities/zone/zone'

import { Schedule } from './schedule'

export class Group {
	public id: number
	public accountId: number
	public accountName?: string
	public musicProfileId: number | null
	public name: string

	public analytics: GroupAnalytics
	public radios?: Radio[]
	public campaigns?: Campaign[]
	public mixes?: Mix[]
	public zones?: Zone[]
	public musicProfile?: MusicProfile
	public schedules?: Schedule[]
	public playlists?: Playlist[]
	public directPlaylists?: number

	constructor(data: {
		id: number
		accountId: number
		accountName?: string
		musicProfileId: number | null
		name: string
		analytics: GroupAnalytics
		radios?: Radio[]
		campaigns?: Campaign[]
		mixes?: Mix[]
		zones?: Zone[]
		musicProfile?: MusicProfile
		schedules?: Schedule[]
		playlists?: Playlist[]
		directPlaylists?: number
	}) {
		this.id = data.id
		this.accountId = data.accountId
		this.accountName = data.accountName
		this.musicProfileId = data.musicProfileId
		this.name = data.name
		this.analytics = data.analytics
		this.radios = data.radios
		this.campaigns = data.campaigns
		this.mixes = data.mixes
		this.zones = data.zones
		this.musicProfile = data.musicProfile
		this.schedules = data.schedules
		this.playlists = data.playlists
		this.directPlaylists = data.directPlaylists
	}

	static create(partial: Partial<Group>): Group {
		const defaults = {
			id: 0,
			accountId: 0,
			musicProfileId: null,
			name: '',
			analytics: GroupAnalytics.create({
				players: 0,
				announcements: 0,
				mixes: 0,
				radios: 0,
				schedules: 0,
				playlists: 0,
				adverts: 0,
			}),
		}

		// Merge defaults with provided data
		return new Group({ ...defaults, ...partial })
	}

	clone(): Group {
		return new Group({ ...this })
	}
}

export class GroupAnalytics {
	public players: number
	public announcements: number
	public mixes: number
	public radios: number
	public schedules: number
	public playlists: number
	public adverts: number

	constructor(data: {
		players: number
		announcements: number
		mixes: number
		radios: number
		schedules: number
		playlists: number
		adverts: number
	}) {
		this.players = data.players
		this.announcements = data.announcements
		this.mixes = data.mixes
		this.radios = data.radios
		this.schedules = data.schedules
		this.playlists = data.playlists
		this.adverts = data.adverts
	}

	static create(partial: Partial<GroupAnalytics>): GroupAnalytics {
		const defaults = {
			players: 0,
			announcements: 0,
			mixes: 0,
			radios: 0,
			schedules: 0,
			playlists: 0,
			adverts: 0,
		}
		return new GroupAnalytics({ ...defaults, ...partial })
	}
}
